import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@/api/client";
import { MeterReading } from "@/meters/meter";

const useLatestMeterReading = (meterId: any) => {
  return useQuery({
    queryKey: [
      "meter-latest-reading",
      meterId,
    ],
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    enabled: !!meterId,
    refetchInterval: 1000 * 60,
    queryFn: async () => {
      return await apiClient.get<MeterReading>(`meters/${meterId}/latest-reading/`);
    },
  });
}

export default useLatestMeterReading;
